// elixirforum.com/t/automatically-clearing-flash-messages-in-phoenix-liveview/
const AutoClearFlashHook = {
  mounted() {
    // let ignoredIDs = ["client-error", "server-error"];
    // if (ignoredIDs.includes(this.el.id)) return;

    let hideElementAfter = this.el.getAttribute("hide-after-ms");
    if (hideElementAfter == 0) return;

    let clearFlashAfter = hideElementAfter + 500; // ms

    // first hide the element
    setTimeout(() => {
      this.el.style.opacity = 0;
    }, hideElementAfter);

    // then clear the flash
    setTimeout(() => {
      if (this.view && this.view.isConnected()) {
        this.pushEvent("lv:clear-flash", { key: this.el.dataset.key });
      }
      this.el.style.display = "none";
    }, clearFlashAfter);
  },
};

export default AutoClearFlashHook;
